import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {}

interface Variables {
    applicationId: string,
    newStatus: 'IN_PROGRESS' | 'APPROVED' | 'REJECTED'
}

export const UPDATE_APPLICATION_STATUS: TypedDocumentNode<Result, Variables> = gql`
    mutation UpdateApplicationStatus($applicationId: Int!, $newStatus: EnumApplicationStatus){
        updateApplicationStatus(applicationId: $applicationId, newStatus: $newStatus)
    }       
`
